import { fetchProjects } from 'common/api/v1/searchi';

import {
    FETCH_PROJECTS,
    FETCH_PROJECTS_FAILURE,
    FETCH_PROJECTS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default (q, page = 1, branchOfficeId = '') =>
    (dispatch) => {
        if (!q) return;

        dispatch(actions[FETCH_PROJECTS]());

        fetchProjects({ q, page, branchOfficeId }).then(
            (response) => {
                dispatch(actions[FETCH_PROJECTS_SUCCESS](response.data));
            },
            (error) => {
                dispatch(
                    actions[FETCH_PROJECTS_FAILURE](error?.response?.data),
                );
            },
        );
    };
